import "./WazawanFileSlug.css";
import { File } from "lucide-react";

type WazawanFileSlugProps = {
    fileName: string;
}

export const WazawanFileSlug = ({fileName} : WazawanFileSlugProps) => {
    return (
        <div className="wazawan-file-slug">
            <File size={16} />{fileName}
        </div>
    )
}